<div class="paybee-modal-header">
    <div class="row">
        <div class="col-10">
            <div class="modal-main-heading">{{data ? 'Edit Webhook Endpoint': 'Add Webhook Endpoint'}}</div>
        </div>
        <div class="col-2">
            <button type="button" class="close cursor--pointer" (click)="close()">
                <span aria-hidden="true" class="black-text cursor--pointer">×</span>
            </button>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <div class="modal-sub-heading">{{data ? "Edit Webhook Endpoint": 'Add a new webhook endpoint to this account'}}</div>
        </div>
    </div>
</div>

<div class="modal-body custom-material-form" [formGroup]="form">
    <div class="row">
        <div class="col-12">
            <mdb-form-control class="form-fill w-100">
                <mdb-select formControlName="eventType" class="mdb-select" data-panel="general">
                  <mdb-option *ngFor="let eventType of eventTypes" [value]="eventType.id">{{
                    eventType.label
                  }}</mdb-option>
                </mdb-select>
                <label mdbLabel class="form-label form-label--paybee">Select Event Type</label>
                <mdb-error class="form-fill-error" *ngIf="form.controls.eventType.hasError('required') && form.controls.eventType.touched">Please provide Event Type</mdb-error>
            </mdb-form-control>
        </div>
        <div class="col-12">
            <mdb-form-control class="form-fill w-100">
                <app-mdbp-input mdbInput formControlName="url" label='Endpoint URL'></app-mdbp-input>
                <mdb-error class="form-fill-error"  *ngIf="form.controls.url.hasError('required') && form.controls.url.touched">Please provide URL</mdb-error>
                <mdb-error class="form-fill-error"  *ngIf="form.controls.url.hasError('pattern') && form.controls.url.touched">Incorrect format of URL</mdb-error>
            </mdb-form-control>
        </div>
        <div class="col-12">
            <mdb-form-control class="form-fill w-100">
                <app-mdbp-input mdbInput formControlName="name" label='Endpoint Name'></app-mdbp-input>
                <mdb-error class="form-fill-error"  *ngIf="form.controls.name.hasError('required') && form.controls.url.touched">Please provide Name</mdb-error>
            </mdb-form-control>
        </div>
    </div>
</div>

<div class="modal-footer paybee-modal-footer">
    <a class="btn btn-sm modal-cancel-button waves-effect waves-light" (click)="close()">Cancel</a>
    <a class="btn btn-sm modal-confirm-button waves-effect waves-light" (click)="submit()">{{data ? 'Save': 'Add'}}</a>
</div>